(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxStatus', TaxStatus);

    TaxStatus.$inject = ['$resource'];

    function TaxStatus ($resource) {
        var resourceUrl =  'api/tax-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
